import { render } from "./Frecuencia_MedInter.vue?vue&type=template&id=2fed477e"
import script from "./Frecuencia_MedInter.vue?vue&type=script&lang=js"
export * from "./Frecuencia_MedInter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__